import { render } from "./EditNoticeVIew.vue?vue&type=template&id=40799c27&scoped=true"
import script from "./EditNoticeVIew.vue?vue&type=script&lang=js"
export * from "./EditNoticeVIew.vue?vue&type=script&lang=js"

import "./EditNoticeVIew.vue?vue&type=style&index=0&id=40799c27&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40799c27"]])

export default __exports__